import {useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
import {isNew} from 'services/utils/editForm'
import {
    useGetPublicationFolderQuery,
    useSavePublicationFolderMutation,
    useCreatePublicationFolderMutation,
} from 'store/slices/api/publicationFoldersApi'
import {useI18n} from 'store/Store'
import {useAlert} from 'components/Display/Alert/AlertContext'
import {useNavigate} from 'react-router-dom'
import {yupResolver} from '@hookform/resolvers/yup'
import {publicationSchema} from 'services/validations/schemas/publication'

const usePublicationFolderForm = (publicationFolderId) => {
    const {i18n} = useI18n()
    const {showAlert} = useAlert()
    const navigate = useNavigate()

    const [formError, setFormError] = useState(null)

    const [doCreatePublicationFolder] = useCreatePublicationFolderMutation()
    const [doSavePublicationFolder] = useSavePublicationFolderMutation()

    const {data: publicationFolder} = useGetPublicationFolderQuery(
        publicationFolderId,
        {
            skip: isNew(publicationFolderId),
        }
    )

    const form = useForm({
        defaultValues: {isActive: true},
        mode: 'onSubmit',
        resolver: yupResolver(publicationSchema),
    })

    useEffect(() => {
        if (publicationFolder) {
            form.reset(publicationFolder)
        }
    }, [publicationFolder, form])

    const onSubmit = async (values) => {
        let response
        const body = {
            ...values,
        }
        if (values._id) {
            response = await doSavePublicationFolder(body)
        } else {
            response = await doCreatePublicationFolder(body)
        }

        if (response?.data?._id) {
            const message = i18n.t('form.savedSuccessfully', {
                itemName: i18n.t('tables.publicationFolder'),
            })
            navigate(`/publicationFolders/${response.data._id}`)
            showAlert(message)
        }
        if (response.error) {
            setFormError(response.error.data.error)
        }
    }

    const submit = form.handleSubmit(onSubmit)

    return {
        form,
        formError,
        publicationFolder,
        submit,
    }
}

export default usePublicationFolderForm
